import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import MyTable from '../../../../utils/MyTable';

//redux
import { useDispatch, useSelector } from 'react-redux';

//Modals

import { applyMaskAmount, groupArticlePolicys, markArticlesInPortfolio, pureConsoleLog } from "../../../../utils/utils";

import { Tooltip } from "@material-ui/core";

import WarningIcon from '@material-ui/icons/Warning';

import { ArticleRulesAPI } from '../../../../../API/article_rules';
import allActions from '../../../../../actions';
import { headerSearch, tabs, unoTheme } from '../../../../../assets/styles/unoTheme';
import DefaultScrollWithHeaderContent from '../../../../utils/DefaultScrollWithHeaderContent';
import { LegislationArticleAPI } from '../../../../../API/legislation_article';

const LightTooltip = withStyles((theme) => ({
    arrow: {
        "&:before": {
            border: "1px solid #E6E8ED"
        },
        color: theme.palette.common.white
    },
    tooltip: {
        backgroundColor: theme.palette.common.white,
        border: "1px solid #E6E8ED",
        color: "#4A4A4A",
        fontSize: '16px',
    }
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    green: {
        color: unoTheme.greenMoney
    },
    red: {
        color: unoTheme.redMoney,
    },
    iconButton: {
        padding: '5px',
    },
    headerSearch: headerSearch,
    inputSearch: {
        width: "300px",
        background: "white"
    },
    tableTh: {
        //fontWeight: 'bold',
        background: unoTheme.mainColor,
        color: 'white',
    },
    selectableRow: {
        cursor: 'pointer',
        '& > *': {
            borderBottom: 'unset',
            //padding: '3px 12px 3px 8px !important',
        },
        '&:nth-of-type(odd)': {
            backgroundColor: unoTheme.secondaryTuplaTable,
        },
        '&:hover': {
            //color: 'white',
            background: unoTheme.hoverTable,
        }
    },

    table: {
        tableLayout: 'fixed',
        '& .MuiTableRow-head': {
            '& .MuiTableCell-root': {
                borderBottom: 'none',
                color: unoTheme.defaultTextColor,
                fontWeight: '500',
                textTransform: 'uppercase',
                fontSize: '12px',
                padding: '16px 24px 16px 16px',
            },
        },
    },

    overflow: {
        overflowY: 'scroll',
    },
    tableSideGraph: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
    },
    rightGraphs: {
        width: '30%',
    },
    clickAble: {
        cursor: 'pointer'
    },
    sectionTableCell: {
        display: 'table-cell',
        color: 'white',
        padding: '0px !important',
    },
    multipleHorizontalTableCell: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'space-around',
        '& > div': {
            width: '33%',
        }
    },
    toogleButton: {
        maxHeight: '40px',
    },

    errorArticle: {
        color: unoTheme.errorColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .MuiSvgIcon-root': {
            fontSize: '20px',
            marginRight: '5px',
        }

    },

    iconExtraPolicys: {

        '& .MuiSvgIcon-root': {
            fontSize: '18px',
            verticalAlign: 'middle',
        }

    },

    tabs: tabs,

    sectionTableCellData: {
        width: '30%',
        display: 'table-cell',
        padding: '0px !important',
    },

    myTableFooter: {
        cursor: "pointer",
        borderBottom: 'unset',
        '& > *': {
            borderBottom: 'unset',
        },
        '& .MuiTableCell-root': {
            borderBottom: 'unset',
            color: 'white',
            background: unoTheme.mainColor,
        },

        '& .MuiTableCell-root:first-child': {
            borderTopLeftRadius: '10px',
            borderBottomLeftRadius: '10px',
        },

        '& .MuiTableCell-root:last-child': {
            borderTopRightRadius: '10px',
            borderBottomRightRadius: '10px',
        },

        '& .spanTotal': {
            //color: unoTheme.greenMoney,
            fontSize: '14px',
        }
    },

    pendent: {
        color: unoTheme.warningColor,
        cursor: 'pointer',
        fontSize: '1.2em',
        verticalAlign: 'middle',
    },


}));

export default function ArticlesTableTab(props) {

    const { assets, segment, isLoading, legislationArticles,
        setListLegislationArticles, totalPortfolioBalance,
        totalArticlesBalance,
        assetsByRule, month } = props

    const classes = useStyles();
    const location = useLocation();
    const clientOn = useSelector(state => state.clientOn)

    const dispatch = useDispatch();

    const [limitPortfolioMode, setLimitPortfolioMode] = useState('porcent');
    const [presentationNameMode, setPresentationNameMode] = useState('name');

    const [innerLoad, setInnerLoad] = useState({ emptyMessage: "", loadMessage: "Carregando informações...", size: "small" });

    function getWarningMessageArticleRules(assetsInRule) {

        const nodes = [];
        Object.entries(assetsInRule).map(([key, row]) => {
            if (row.rule) {
                nodes.push(<p style={{ fontSize: '14px' }}>Os saldos dos ativos referentes a regra <span style={{ color: unoTheme.mainColor, fontWeight: 'bold' }}>{row.rule.name}</span> encontram-se desenquadrados</p>);
            }
        });

        return nodes;

    }

    const getCurrentExtraPolicy = (policy, selectedMonth, theTargetCode) => {

        if (!policy.extrasPolicys) return "-";
        if (policy.extrasPolicys[selectedMonth]) return policy.extrasPolicys[selectedMonth][theTargetCode] + "%";

        for (let index = (selectedMonth - 1); index >= 1; index--) {
            const stringMonth = index.toString();
            if (policy.extrasPolicys[stringMonth]?.[theTargetCode]) return policy.extrasPolicys[stringMonth][theTargetCode] + "%";

        }

        return "-";
    }

    return (
        <div className={classes.root}>

            <DefaultScrollWithHeaderContent innerLoad={isLoading}>
                <div className={classes.tableSideGraph}>
                    {

                        <MyTable stickyHeader
                            nofixed={true}
                            size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className={[classes.clickAble].join(' ')} align="left"
                                        onClick={() => setPresentationNameMode(presentationNameMode == 'name' ? 'class' : 'name')}>
                                        {'Tipo de ativo'}
                                    </TableCell>
                                    {/*art13*/}
                                    <TableCell align="center"></TableCell>
                                    {/*art14*/}
                                    <TableCell align="center"></TableCell>
                                    {/*art18 fund em relação a carteira*/}
                                    <TableCell align="center"></TableCell>
                                    {/*art19 fund em relação ao pl anbima*/}
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center" style={{ display: "flex", alignItems: 'center', gap: '8px' }}>
                                        Resol. (%) {clientOn.client?.promanagement_code ? '[PG ' + clientOn.client?.promanagement_code + ']' : ''}
                                        {
                                            assetsByRule?.outRule &&
                                            <LightTooltip button title={<div>{getWarningMessageArticleRules(assetsByRule)}</div>}
                                                className={classes.pendent}
                                                enterDelay={100}
                                                leaveDelay={100}
                                                placement="bottom" arrow>
                                                <WarningIcon />
                                            </LightTooltip>
                                        }

                                    </TableCell>
                                    <TableCell
                                        className={[classes.clickAble].join(' ')} align="center"
                                        onClick={() => setLimitPortfolioMode(limitPortfolioMode == 'value' ? 'porcent' : 'value')}>Carteira {limitPortfolioMode == 'value' ? '(R$)' : '(%)'}</TableCell>
                                    <TableCell align="center"></TableCell>
                                    <TableCell align="center">
                                    </TableCell>
                                    <TableCell className={classes.sectionTableCell}
                                        align="center">
                                        <div>{'Estratégia de alocação'}</div>
                                        <div className={classes.multipleHorizontalTableCell}>
                                            <div>{'Inferior (%)'}</div>
                                            <div>{'Alvo (%)'}</div>
                                            <div>{'Superior (%)'}</div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {legislationArticles
                                    .filter(el => el.isInPortfolio)
                                    .map((row) => (

                                        <TableRow key={'article-' + row.id}
                                            className={classes.selectableRow}>
                                            <LightTooltip button title={row.description} enterDelay={100} leaveDelay={100} placement="bottom" arrow>
                                                <TableCell align="left">
                                                    {presentationNameMode == 'name' ? row.asset : row.device}
                                                </TableCell>
                                            </LightTooltip>

                                            {/* art 13 */}
                                            <TableCell align="center">
                                                {row.assetsOutArt13 && row.assetsOutArt13.length > 0 ?
                                                    <LightTooltip button title={"DESENQUADRADO NO ARTIGO 13"}
                                                        className={classes.pendent}
                                                        enterDelay={100}
                                                        leaveDelay={100}
                                                        placement="bottom" arrow>
                                                        <WarningIcon />
                                                    </LightTooltip> : null}
                                            </TableCell>

                                            {/* art 14 */}
                                            <TableCell align="center">
                                                {row.assetsOutArt14 && row.assetsOutArt14.length > 0 ?

                                                    <LightTooltip
                                                        button
                                                        className={classes.pendent}
                                                        title={"DESENQUADRADO NO ARTIGO 14"}
                                                        enterDelay={100}
                                                        leaveDelay={100}
                                                        placement="bottom"
                                                        arrow>
                                                        <WarningIcon />
                                                    </LightTooltip> : null}
                                            </TableCell>

                                            {/* art 18 */}
                                            <TableCell align="center">
                                                {row.assetsOutArt18 && row.assetsOutArt18.length > 0 ?
                                                    <LightTooltip button title={"Existem fundos desenquadrados no Art. 18. \n As aplicações em cotas de um mesmo fundo de investimento, fundo de investimento em cotas de fundos de investimento ou fundo de índice não podem, direta ou indiretamente, exceder a 20% (vinte por cento) das aplicações dos recursos do regime próprio de previdência social."}
                                                        className={classes.pendent}
                                                        enterDelay={100}
                                                        leaveDelay={100}
                                                        placement="bottom" arrow>
                                                        <WarningIcon style={{ color: unoTheme.redMoney }} />
                                                    </LightTooltip> : null}
                                            </TableCell>

                                            {/* art 19 */}
                                            <TableCell align="center">
                                                {row.assetsOutArt19 && row.assetsOutArt19.length > 0 ?
                                                    <LightTooltip button title={"Existem fundos desenquadrados no Art. 19. \n O total das aplicações dos recursos do regime próprio de previdência social em um mesmo fundo de investimento deverá representar, no máximo, 15% (quinze por cento) do patrimônio líquido do fundo, observado o disposto no art. 16."}
                                                        className={classes.pendent}
                                                        enterDelay={100}
                                                        leaveDelay={100}
                                                        placement="bottom" arrow>
                                                        <WarningIcon style={{ color: unoTheme.redMoney }} />
                                                    </LightTooltip> : null}
                                            </TableCell>

                                            <TableCell align="center">{row.limit_resolution}%</TableCell>
                                            {
                                                limitPortfolioMode == 'porcent' ?

                                                    //No caso de ser o modelo de porcentagem                                                                                                                                
                                                    <TableCell align="center">
                                                        {
                                                            (row.totalArticleValue * 100
                                                                / totalPortfolioBalance) > row.limit_resolution ?
                                                                // Caso o valor seja superior ao limite da resolução ele aparece vermelho com o ícone de alerta
                                                                <div className={classes.errorArticle}>
                                                                    {<WarningIcon />} {parseFloat(row.totalArticleValue * 100 / totalPortfolioBalance).toFixed(2)}%
                                                                </div>
                                                                :
                                                                <div className={totalPortfolioBalance != 0 && parseFloat(row.totalArticleValue * 100 / totalPortfolioBalance).toFixed(2) != '0.00' ? classes.green : null}>
                                                                    {totalPortfolioBalance != 0 ? parseFloat(row.totalArticleValue * 100 / totalPortfolioBalance).toFixed(2) : "0.00"}%
                                                                </div>

                                                        }



                                                    </TableCell>
                                                    :
                                                    <TableCell align="center">
                                                        {

                                                            row.totalArticleValue * 100 /
                                                                totalPortfolioBalance > row.limit_resolution ?
                                                                // Caso o valor seja superior ao limite da resolução ele aparece vermelho com o ícone de alerta
                                                                <div className={classes.errorArticle}>
                                                                    {<WarningIcon />} {applyMaskAmount(row.totalArticleValue, true)}
                                                                </div>

                                                                :
                                                                <div>
                                                                    {applyMaskAmount(row.totalArticleValue, true)}
                                                                </div>

                                                        }



                                                    </TableCell>
                                            }
                                            <TableCell align="center">
                                                {
                                                    //Caso esteja abaixo do lower
                                                    row.outLowerTarget ||
                                                        //Caso esteja acima do top
                                                        row.outTopTarget ?
                                                        <LightTooltip button title={

                                                            row.outLowerTarget ?
                                                                "Abaixo do alvo inferior da extratégia de alocação"
                                                                :
                                                                "Acima do alvo superior da estratégia de alocação"
                                                        }
                                                            className={classes.pendent}
                                                            enterDelay={100}
                                                            leaveDelay={100}
                                                            placement="bottom" arrow>
                                                            <WarningIcon />
                                                        </LightTooltip> : null
                                                }
                                            </TableCell>
                                            <TableCell align="center" className={classes.iconExtraPolicys}>
                                                {clientOn.client?.selectedPortfolioMonth && row.extrasPolicys
                                                    && row.extrasPolicys[clientOn.client.selectedPortfolioMonth] ?

                                                    <LightTooltip button title={"Alteração de política realizada para o mesmo ano de " + clientOn.client.selectedPortfolioYear} enterDelay={100} leaveDelay={100} placement="bottom" arrow>
                                                        <WarningIcon />
                                                    </LightTooltip> : null}
                                            </TableCell>


                                            <TableCell align="center" className={classes.sectionTableCellData}>


                                                {/* Caso haja multipla política e a política do mês selecionado seja uma política extra */}
                                                {
                                                    clientOn.client?.selectedPortfolioMonth && row.extrasPolicys ?


                                                        <div className={classes.multipleHorizontalTableCell}>
                                                            <div>{getCurrentExtraPolicy(row, month, 'lower_target') ?? '-'}</div>
                                                            <div>{getCurrentExtraPolicy(row, month, 'target') ?? '-'}</div>
                                                            <div>{getCurrentExtraPolicy(row, month, 'top_target') ?? '-'}</div>
                                                        </div>

                                                        :

                                                        <div className={classes.multipleHorizontalTableCell}>
                                                            <div>{row.lower_target ? row.lower_target + '%' : '-'}</div>
                                                            <div>{row.target ? row.target + '%' : '-'}</div>
                                                            <div>{row.top_target ? row.top_target + '%' : '-'}</div>
                                                        </div>


                                                }





                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>


                            {
                                totalArticlesBalance &&
                                <TableFooter className={classes.myTableFooter}>
                                    <TableRow key={'footer-t-assets'}>
                                        <TableCell align="left">Total</TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="right"></TableCell>
                                        <TableCell align="center">
                                            <span className={'spanTotal'}>{limitPortfolioMode == 'porcent' ?
                                                applyMaskAmount((totalArticlesBalance / totalPortfolioBalance * 100)) + "%"
                                                :
                                                applyMaskAmount(totalArticlesBalance, true)}</span>
                                        </TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                        <TableCell align="center"></TableCell>
                                    </TableRow>
                                </TableFooter>
                            }


                        </MyTable>
                    }

                </div>

            </DefaultScrollWithHeaderContent>

        </div>
    );
}



